<template>
  <Card dis-hover>
    <div slot="title">
      <slot name="title"></slot>
      <p class="title-item">{{ this.$t('common.date_now') }}</p>
    </div>
    <!-- <a href="#" slot="extra">
      <slot name="extra"></slot>
      <Button
        size="small"
        type="dashed"
        class="extra-btn"
        @click="goToCustom"
        v-if="hasPageAccess('CUSTOMER_DATA')"
      >
        {{ $t('common.more') }}
        <Icon type="ios-arrow-forward" />
      </Button>
    </a> -->
    <!-- 门店得分 -->
    <div class="top-line">
      <p></p>
      <!-- <Select
        v-model="sortWay"
        :transfer="false"
        style="width: 80px; height: 32px"
        @on-change="sortChange"
      >
        <Option value="desc" key="top">TOP</Option>
        <Option value="asc" key="last">LAST</Option>
      </Select> -->
    </div>
    <div class="content">
      <board-two-item
        v-for="(item, index) in StoreList"
        :key="item.id"
        :storeItem="item"
        :storeIndex="index"
        :totalNum="totalNum"
        :currentPage="currentPage"
      ></board-two-item>
      <Spin size="large" v-if="isLoading" fix></Spin>
      <div
        v-if="!isLoading && (!StoreList || StoreList.length === 0)"
        class="no-data"
      >
        {{ $t('common.no_data') }}
      </div>
    </div>
    <!-- <div style="display: flex; justify-content: space-around; margin-top: 10px">
      <Page
        :total="totalPage"
        :page-size="5"
        :current="currentPage"
        size="small"
        @on-change="changPage"
      />
    </div> -->
  </Card>
</template>
<script>
import boardTwoItem from './boardTwoItem.vue';
import api from '../../../api/home/index';
import { privileageAccess } from '../../../mixins/privileage';
export default {
  mixins: [privileageAccess],
  components: {
    boardTwoItem,
  },
  data() {
    return {
      sortWay: 'desc',
      StoreList: [],
      totalPage: null,
      currentPage: 1,
      isLoading: false,
      totalNum: null,
    };
  },
  mounted() {
    this.isLoading = true;
    this.getData(1);
  },
  methods: {
    // 分页
    getData(a) {
      this.isLoading = true;

      this.pageShopScore(this.sortWay).then(() => {
        this.currentPage = a;
      });
    },
    // 排序
    sortChange(type) {
      this.isLoading = true;
      // console.log(value);
      // let params = {
      //   timeRange: 3,
      //   tagIdList: [],
      //   sourceTypeList: [],
      //   showCompare: 0,
      //   deptNode: ['O_5888'],
      //   checkerType: 2,
      //   role: [],
      //   user: [],
      //   templateId: [],
      //   sort: value,
      //   pageNumber: 1,
      //   pageSize: 5,
      // };
      // // console.log(this.totalPage);
      this.pageShopScore(type).then(() => {
        this.currentPage = 1;
      });
    },

    async pageShopScore(type) {
      let newParam = {
        timeType: 2,
        topNum: 10,
      };
      await api
        .getFlowRank(newParam)
        .then(data => {
          // console.log(data);
          if (type === 'desc') {
            this.StoreList = data.dataDesc;
            this.totalNum = this.StoreList.reduce((acc, cur) => {
              return acc + cur.incount;
            }, 0);
          } else {
            this.StoreList = data.dataAsc;
            this.totalNum = this.StoreList.reduce((acc, cur) => {
              return acc + cur.incount;
            }, 0);
          }
          this.isLoading = false;
        })
        .catch(e => {
          console.log(e);
          this.isLoading = false;
        });
    },
    goToCustom() {
      this.$system.goRouter({
        router: {
          //路由跳转信息,必填
          // system: ccconstants.SYSTEM_NOS.Web_Angular, //系统编号，用于辨识该功能模块现在做在哪个系统里面
          // url: '/klfx/pm', //跳转路径，需要填写在相应系统里面的路由地址
          system: ccconstants.SYSTEM_NOS.Web_People_Counting, //系统编号，用于辨识该功能模块现在做在哪个系统里面
          url: '/passenger-flow/data/rank', //跳转路径，需要填写在相应系统里面的路由地址(运营分析-排行)
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep {
  .ivu-card-head p {
    width: auto;
  }
}
.title-item {
  padding: 0 5px;
  height: 18px;
  background: rgba(255, 255, 255, 0.11);
  border-radius: 3px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 12px;
  color: #b2b2b2;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  margin-left: 6px;
}
.top-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative !important;
  margin-bottom: 4px;
  .title {
    display: inline-block;
    margin-right: 5px;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
  }
}

.content {
  height: 200px;
  overflow-y: auto;
  .rank-index {
    display: inline-block;
    width: 22px;
    height: 22px;
    line-height: 22px;
    border-radius: 6px;
    background: #f0f0f0;
    color: #333333;
    text-align: center;
  }
  ::v-deep {
    .ivu-spin-fix {
      background: none !important;
    }
  }
}
::v-deep {
  .ivu-progress-outer {
    margin-top: 4px;
  }
}
</style>
